<template>
  <div style="background-color: #f0f4f7;padding-bottom: 200px;">
    <AboutBanner :content="banners[0].details" :title="banners[0].title" :img="banners[0].photo_file"/>
    <AboutTitle title="مجموعه شیشه اردکان"/>
      <AboutCart
          v-for="(item,index) in companyIntro.topics" :key="index"
          :title="item.title"
          :content="item.details" :img="item.photo_file"/>

  </div>
</template>

<script>
import AboutTitle from "../Components/AboutTitle";
import AboutCart from "../Components/AboutCart";
import AboutBanner from "../Components/AboutBanner";
import {mapState} from "vuex";

export default {
  name: "AboutCompany",
  components: {AboutBanner, AboutCart, AboutTitle},
  created() {
    if (this.banners==null){
      this.$store.dispatch('materialManagement/getMaterialBanners');
    }
    this.$store.dispatch('materialManagement/getCompanyIntro');
  },
  computed: {
    ...mapState({
      companyIntro: state => state.materialManagement.companyIntro,
      banners: state => state.materialManagement.materialBanners,
    })
  }
}
</script>

<style scoped>

</style>